// WRITE ONLY HIGLIGHTED CODE

const TextColor1 = `<span className="color-txt--primary">Primary colored text</span>`;
const BackgroundColor1 = `<span className="color-bg--grey-d1">Background grey color</span>`;

export {TextColor1, BackgroundColor1};
